"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FSMRepoInterceptor = void 0;

var _yup = require("yup");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MODULE_NAME = "fsm.interceptor";
var ENTITY = "fsm";
var ERROR_LOOKUP_TABLE = {
  UNPROCESSABLE_ENTITY: {
    error_code: "422",
    error_type: "INVALID_INPUT",
    error_message: "invalid input",
    display_message: "invalid input"
  },
  UNKNOWN_ERROR: {
    error_code: "500",
    error_type: "UNKNOWN_ERROR",
    error_message: null,
    display_message: "unknown error in ".concat(ENTITY, " Interceptor")
  }
};
var CreateSchema = (0, _yup.object)().shape({
  id: (0, _yup.string)().trim().required(),
  initial: (0, _yup.string)().trim().required(),
  context: (0, _yup.object)().unknown(),
  states: (0, _yup.object)().unknown().required()
});
var GetSchema = (0, _yup.object)().shape({
  type: (0, _yup.string)().trim().required().oneOf(["id"]),
  value: (0, _yup.string)().trim().required()
});
var DeleteSchema = (0, _yup.object)().shape({
  type: (0, _yup.string)().trim().required().oneOf(["id"]),
  value: (0, _yup.string)().trim().required()
});
var TransitToSchema = (0, _yup.object)().shape({
  id: (0, _yup.string)().trim().required(),
  type: (0, _yup.string)().trim().required()
});
var UpdateSchema = (0, _yup.object)().shape({
  id: (0, _yup.string)().trim().required(),
  currentState: (0, _yup.object)().unknown().required()
});

var FSMRepoInterceptor = /*#__PURE__*/function () {
  function FSMRepoInterceptor() {
    _classCallCheck(this, FSMRepoInterceptor);
  }

  _createClass(FSMRepoInterceptor, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var args,
            res,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.prev = 1;
                _context.next = 4;
                return CreateSchema.validate(args);

              case 4:
                res = _context.sent;
                res = _objectSpread(_objectSpread({}, args), res);
                return _context.abrupt("return", res);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", {
                  error: _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNPROCESSABLE_ENTITY), {}, {
                    error_message: _context.t0.message,
                    display_message: _context.t0.message
                  })
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var args,
            res,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                args = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                _context2.prev = 1;
                _context2.next = 4;
                return GetSchema.validate(args);

              case 4:
                res = _context2.sent;
                res = _objectSpread(_objectSpread({}, args), res);
                return _context2.abrupt("return", res);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", {
                  error: _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNPROCESSABLE_ENTITY), {}, {
                    error_message: _context2.t0.message,
                    display_message: _context2.t0.message
                  })
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "transitTo",
    value: function () {
      var _transitTo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var args,
            res,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                args = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                _context3.prev = 1;
                _context3.next = 4;
                return TransitToSchema.validate(args);

              case 4:
                res = _context3.sent;
                res = _objectSpread(_objectSpread({}, args), res);
                return _context3.abrupt("return", res);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", {
                  error: _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNPROCESSABLE_ENTITY), {}, {
                    error_message: _context3.t0.message,
                    display_message: _context3.t0.message
                  })
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      function transitTo() {
        return _transitTo.apply(this, arguments);
      }

      return transitTo;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var args,
            res,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                args = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
                _context4.prev = 1;
                _context4.next = 4;
                return UpdateSchema.validate(args);

              case 4:
                res = _context4.sent;
                res = _objectSpread(_objectSpread({}, args), res);
                return _context4.abrupt("return", res);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", {
                  error: _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNPROCESSABLE_ENTITY), {}, {
                    error_message: _context4.t0.message,
                    display_message: _context4.t0.message
                  })
                });

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 9]]);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var args,
            res,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                args = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                _context5.prev = 1;
                _context5.next = 4;
                return DeleteSchema.validate(args);

              case 4:
                res = _context5.sent;
                res = _objectSpread(_objectSpread({}, args), res);
                return _context5.abrupt("return", res);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](1);
                return _context5.abrupt("return", {
                  error: _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNPROCESSABLE_ENTITY), {}, {
                    error_message: _context5.t0.message,
                    display_message: _context5.t0.message
                  })
                });

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 9]]);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new FSMRepoInterceptor();
      }

      return this.instance;
    }
  }]);

  return FSMRepoInterceptor;
}();

exports.FSMRepoInterceptor = FSMRepoInterceptor;

_defineProperty(FSMRepoInterceptor, "instance", void 0);